import { TStore } from "@/models/store";

const getUserState = (state: TStore) => state.userState || {};

// eslint-disable-next-line no-underscore-dangle
const getUserId = (state: TStore) => getUserState(state).userDetail._id;

const getUserDetail = (state: TStore) => getUserState(state).userDetail;

const getCoupons = (state: TStore) =>
    getUserState(state).userDetail?.coupons || [];

const getUserCoupon = (state: TStore, couponName: string) =>
    getCoupons(state).find(coupon => coupon === couponName);

const getPaymentMethods = (state: TStore) =>
    getUserState(state).userDetail?.paymentMethods || [];

export {
    getUserState,
    getUserId,
    getUserDetail,
    getPaymentMethods,
    getCoupons,
    getUserCoupon,
};
